import { teamSlice } from "./store/team.slice";
import {
  teamApi,
  useGetTeamsQuery,
  useCreateTeamMutation,
  useUpdateTeamMutation,
  useLazyGetTeamByIdQuery,
  useLazyGetTeamsQuery,
  useDeleteTeamMutation
} from "./api/team.api";

export const { setTeams } = teamSlice.actions;

export {
  teamApi,
  teamSlice,
  useGetTeamsQuery,
  useCreateTeamMutation,
  useUpdateTeamMutation,
  useLazyGetTeamByIdQuery,
  useLazyGetTeamsQuery,
  useDeleteTeamMutation
};
